
export default {
  SET_ERRORS: (state, payload) => state.errors = payload,
  SET_NOOP: () => {}
}